<template>
  <v-row justify="center">
    <v-dialog v-model="mostrar" persistent max-width="800px">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{this.configuracion.titulo_modal}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
                  <v-col cols="12" v-for="input in this.inputs" :key="input.key">
                    <!-- input de tipo "texto" -->
                    
                    <v-text-field
                      v-if="input.tipo=='texto'"
                      color="blue"
                      :label="input.label"
                      required
                      v-model="input.valor"
                    >
                      <template v-slot:label v-if="input.info">
                        {{ input.label }}
                        <v-icon color="blue" :title="input.info" class="">info</v-icon>
                      </template>
                    </v-text-field>

                    <!-- input de tipo "select" -->
                    <span v-if="input.tipo=='select'">
                        <v-select
                          v-model="input.valor"
                          :items="input.opciones"
                          :item-text="input.texto"
                          :item-value="input.seleccion"
                          :label="input.label"
                          color="blue darken-3"
                          persistent-hint
                          return-object
                        ></v-select>
                      
                    </span>

                    <!-- input de tipo select que carga información a otro select del modal -->
                    <span v-if="input.tipo=='select_loadable' && input.key == 'punto_mediciones_id'">
                      
                        <v-select
                          v-model="input.valor"
                          :items="input.opciones"
                          :item-text="input.texto"
                          :item-value="input.seleccion"
                          :label="input.label"
                          color="blue darken-3"
                          persistent-hint
                          return-object
                          @change="cargarOpciones(input)"
                        ></v-select>
                      
                    </span>

                    <!-- input de tipo select que carga información a otro select (configurable) -->
                    <span v-if="input.tipo=='select_loadable_configurable'">
                      
                        <v-select
                          v-model="input.valor"
                          :items="input.opciones"
                          :item-text="input.texto"
                          :item-value="input.seleccion"
                          :label="input.label"
                          color="blue darken-3"
                          persistent-hint
                          return-object
                          @change="cargarOpcionesConfigurable(input)"
                        ></v-select>
                      
                    </span>

                    <!-- input de tipo "numero" -->
                    <span v-if="input.tipo == 'numero'">
                      
                        <v-text-field type="number" v-model="input.valor" :label="input.label" color="blue darken-3"></v-text-field>
                      
                    </span>

                    <!-- input de tipo fecha -->
                    <span v-if="input.tipo == 'fecha'">
                      
                        <v-datetime-picker 
                        label="Seleccione Fecha y Hora*"
                        dateFormat="dd-MM-yyyy"
                        timeFormat="HH:mm"
                        clearText="Borrar"
                        okText="Aceptar"
                        v-model="input.valor" :multiple="false"></v-datetime-picker>
                      
                    </span>

                    <!-- input de tipo autocomplete -->
                    <span v-if="input.tipo == 'autocomplete'">
                      
                        <v-autocomplete
                                            v-model="input.valor"
                                            :items="input.opciones"
                                            :item-text="input.texto"
                                            :item-value="input.seleccion"
                                            :label="input.label"
                                            color="blue darken-3"
                                            persistent-hint
                                            return-object
                                            dense
                        ></v-autocomplete>
                      
                    </span>
                    <!-- input de tipo autocomplete -->


                    <!-- input color picker -->
                    <v-color-picker v-if="input.tipo == 'color_picker'" v-model="input.valor" mode="hexa" :hide-mode-switch="true" :dot-size="20"></v-color-picker>
                    <!-- input color picker -->

                    <!-- input de hora -->
                    <v-menu v-if="input.tipo == 'timer'"
                      ref="menus"
                      v-model="input.picker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.valor"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="input.valor"
                          :label="input.label"
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="input.picker"
                        v-model="input.valor"
                        full-width
                        @click:minute="$refs.menus[input.index].save(input.valor)"
                      ></v-time-picker>
                    </v-menu>
                    <!-- input de hora -->


                    <!-- input de tipo switch -->
                    <v-switch v-if="input.tipo == 'switch'"
                      v-model="input.valor"
                      :label="input.label"
                    ></v-switch>
                    <!-- input de tipo switch -->

                   

                  </v-col>
            </v-row>

            <!--  alert para mostrar algun mensaje de información -->
            <v-row>
              <v-col>
                    <v-alert v-if="configuracion.mensaje != '' && configuracion.mensaje != undefined" :type="configuracion.tipo_mensaje">
                      {{this.configuracion.mensaje}}
                    </v-alert>
              </v-col>
            </v-row>
            <!--  alert para mostrar algun mensaje de información -->

          </v-container>
          <small>*Campos Requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="cerrarModal">Cerrar</v-btn>
          <v-btn color="green darken-1" dark @click="submit">{{this.configuracion.boton_submit}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
// import axios from 'axios'
export default {
    data:()=>({
        mostrar:false,
        inputs:[],
        configuracion:{}
    }),
    // created() {
    //     Event.$on('abrir',(inputs,configuracion)=>{
    //         console.log('Abriendo modal',inputs);
    //         this.mostrar = true;
    //         this.inputs = inputs;
    //         this.configuracion = configuracion;
    //     })
    // },
    beforeDestroy() {
      Event.$off('abrir');
    },
    mounted() {
      Event.$on('abrir',(inputs,configuracion)=>{
            console.log('Abriendo modal',inputs);
            console.log('ejecuta el Event');
            this.mostrar = true;
            this.inputs = inputs;
            this.configuracion = configuracion;
      });

      /**hace referencia al padre donde se encuentre el componente */
      this.$parent.$on('abrir', (inputs,configuracion)=>{
        console.log('ejecuta el this.$emit');
        this.inputs = inputs;
        this.configuracion = configuracion;
        this.mostrar = true;
      });

    },
    methods:{
        async submit(){
          //this.mostrarLoading('Realizando...');
            this.mostrarLoading({titulo:'Realizando...',color:'green'})

            let body = {};
            console.log('inputs',this.inputs);
            await this.inputs.forEach(input => {
                if(input.tipo == 'texto' || input.tipo == 'numero' || input.tipo == 'hidden'){
                    body[input.key] = input.valor;
                }
                else if(input.tipo == 'select' || input.tipo == 'autocomplete'){
                  console.log(`select ${input.key}`,input);
                  if(input.valor != undefined){
                    body[input.key] = input.valor.id;
                  }
                }else if(input.tipo == 'fecha'){

                  body[input.key] = this.moment(input.valor).format('YYYY-MM-DD HH:mm');
                }else if(input.tipo == 'color_picker'){
                  body[input.key] = input.valor;
                  console.log('valor color',input.valor);
                }else if(input.tipo == 'timer'){
                  body[input.key] = input.valor;
                }else if(input.tipo == 'switch'){
                  body[input.key] = input.valor?1:0;
                }
                // console.log('key',input.key);
                
            });
            console.log('body',body);
            let url = `${this.base_url}${this.configuracion.ruta}`;

            if(this.configuracion.tipo_peticion == 'POST'){
                await this.axios.post(url,body,this.headers).then((response)=>{
                    this.ocultarLoading();
                    this.cerrarModal();
                    //Event.$emit('peticion_realizada')
                    this.$emit('peticionrealizada');
                }).catch((error)=>{
                    console.log('error',error);
                    this.ocultarLoading();
                    this.cerrarModal();
                })
                console.log(this.inputs);
            }else if(this.configuracion.tipo_peticion == 'PUT'){
              await this.axios.put(url,body,this.headers).then((response)=>{
                    this.ocultarLoading();
                    this.cerrarModal();
                    //Event.$emit('peticion_realizada')
                    this.$emit('peticionrealizada');
              }).catch((error)=>{
                    console.log('error',error);
                    this.ocultarLoading();
                    this.cerrarModal();
              })
            }
            
        },
        async cargarOpciones(input){
          console.log('input',input);
          await this.axios.get(`${this.base_url}${input.ruta_opciones}${input.valor.id}`,this.headers).then((response)=>{
            console.log('indicadores_punto_medicion',response.data.data);
            let opciones = [];
            response.data.data.forEach(opc => {
              opciones.push({id:opc.id,texto:`${opc.id} - ${opc.equipos_procesos.tipo_equipo.tipo_equipo} - ${opc.equipos_procesos.nombre_equipo} - ${opc.parametros.nombre_parametro}`});
            });
            this.inputs[input.select_a_cargar].opciones = opciones;
          }).catch((error)=>{
            console.log('error',error);
          })
        },

        async cargarOpcionesConfigurable(input){
          let url = `${this.base_url}${input.ruta_opciones}${input.valor.id}`;
          let opciones = [];
          await this.axios.get(url,this.headers).then((response)=>{
            response.data.data.forEach(opc=>{
              /*por cada opcion*/
              opciones.push({id:opc.id,texto:opc[input.texto_opcion]});
            });
            console.log(opciones);
            this.inputs[input.select_a_cargar].opciones = opciones;
          }).catch((error)=>{
              console.log('error',error);
          });
        },

        cerrarModal(){
            this.mostrar = false;
            this.limpiarModal();
        },

        limpiarModal(){
          this.inputs.forEach(input => {
            input.valor = '';
          });
        },

        ...mapMutations(['mostrarLoading','ocultarLoading']),
    },
    computed: {
        ...mapState(['base_url','headers']),
    },
}
</script>